import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24 0v24H0V0h24z",
		fill: "none",
		opacity: .87
	}), /* @__PURE__ */ _jsx("path", { d: "M14 7l-5 5 5 5V7z" })]
});
export default SvgArrowLeft;
